import { useLoggedInUser } from "Hooks/useLoggedInUser";
import type { CurrencyCode } from "Models/CurrencyCodes";
import { getRegionCurrency } from "Utils/CurrencyUtils";

/**
 * Currency of the logged-in user's market (CZ -> CZK, SK -> EUR). For an Employee
 * context the region already carries the EMPLOYER's market (resolved server-side),
 * so this matches the currency useAmount stamps on payment payloads.
 *
 * Returns undefined for a region-less context — money must never fall back to a
 * guessed currency; callers decide how to render the absence.
 */
export const useUserMarketCurrency = (): CurrencyCode | undefined => {
  const user = useLoggedInUser();
  return user?.region ? getRegionCurrency(user.region) : undefined;
};
